export const sortByMatch = ( arrayOfObjects: Array<any>, paramsField: string | number ) => {
   return arrayOfObjects.reduce((acc: number, cur: {}) => {
     acc[cur[paramsField]] = [...(acc[cur[paramsField]] || []), cur];
     return acc;
   }, {});
 } 
